// import { asyncRoutes, constantRoutes } from '@/router'
import router from '@/router'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission (roles, route) {
    let routes = router.options.routes
    if (route.resourceUrl && routes && routes.length>0) {
      return routes.some(item => {
        if(route.isMenu==0 && item.path==route.resourceUrl){
          return true
        }
      })
    } else {
      return false
    }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes (routes, roles) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })
  return res
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = routes
  }
}

const actions = {
  generateRoutes ({ commit }, cur) {
    return new Promise(resolve => {
      let accessedRoutes
      let {roles,routes} = cur
      if(roles && roles.length>0 && routes && routes.length){
        routes = routes.map(ele=>{
          ele.path = ele.resourceUrl
          return ele
        })
        accessedRoutes = filterAsyncRoutes(routes, roles)
      }
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
